import { Api } from "./Api.class";
const endpoint = "notifications";
const notificationsAPI = new Api(endpoint);
export default notificationsAPI;
